var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEliotnestLogoV3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 640",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 76.00 80.00 L 436.00 80.00 L 436.00 397.96 Q 436.00 400.96 433.50 402.62 L 256.00 520.96 L 78.50 402.62 Q 76.00 400.96 76.00 397.96 L 76.00 80.00 Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 104.00 108.00 L 408.00 108.00 L 408.00 382.97 Q 408.00 385.97 405.50 387.63 L 256.00 487.30 L 106.50 387.63 Q 104.00 385.97 104.00 382.97 L 104.00 108.00 Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 132.00 136.00 L 380.00 136.00 L 380.00 367.99 Q 380.00 370.99 377.50 372.65 L 256.00 453.65 L 134.50 372.65 Q 132.00 370.99 132.00 367.99 L 132.00 136.00 Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 160.00 164.00 L 352.00 164.00 L 352.00 353.00 Q 352.00 356.00 349.50 357.66 L 256.00 420.00 L 162.50 357.66 Q 160.00 356.00 160.00 353.00 L 160.00 164.00 Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEliotnestLogoV3);
export default __webpack_public_path__ + "static/media/eliotnest-logo-v3.bc3f742dcb8126e207618ad61611ff0c.svg";
export { ForwardRef as ReactComponent };